import { useParams } from "react-router-dom";
import { Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useContext } from "react";
import { currentProject, ProjectContext } from "../ProjectProvider";
import { EventEmitter } from "nate-react-api-helpers";
import { formatProjectNumber } from "../../../api/Projects";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectName() { const project = useProject(); return /*#__PURE__*/ _jsx("div", { style: { paddingRight: 8 }, children: /*#__PURE__*/ _jsx(Tooltip, { title: (project === null || project === void 0 ? void 0 : project.name) || "", children: /*#__PURE__*/ _jsxs(Typography, { variant: "h3", style: { fontSize: "1.1rem", fontWeight: 500, color: grey["800"], maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, children: [project && project.projectNumber > 0 && /*#__PURE__*/ _jsx("span", { style: { color: grey["600"], marginRight: 8 }, children: formatProjectNumber(project.projectNumber) }), project === null || project === void 0 ? void 0 : project.name] }) }) }); }
export function useProjectId() { const params = useParams(); try {
    if (!params.project)
        return 0;
    const v = parseInt(params.project, 10);
    if (isNaN(v))
        return 0;
    return v;
}
catch (e) {
    return 0;
} }
export function useProject() {
    const proj = useContext(ProjectContext);
    const projEmit = EventEmitter.reactValue(currentProject);
    if (proj.value.id !== 0)
        return proj.value; // if not inside of <ProjectProvider> fallback
    return projEmit;
}
export function useProjectUnitSystem() { const proj = useProject(); if (!proj)
    return null; return proj.unitSystem || "imperial"; }
